export enum RPCMethod {
  WalletConnect = 'wallet_connect',
  EthSendTransaction = 'eth_sendTransaction',
  WalletSendCalls = 'wallet_sendCalls',
  PersonalSign = 'personal_sign',
  EthSignTypedDataV4 = 'eth_signTypedData_v4',
}
